module.exports = __webpack_public_path__ + "img/img-prec-variavel-flag.073a8963.png";